import * as React from 'react';

import { localization } from 'src/App/shared/localization/localization';
import { Markdown } from 'src/App/shared/localization/markdown-wrapper';

export interface ISaveMotiveDialogProps {
    onSave(addToGallery: boolean, showOnAll: boolean): void;
}

enum SaveOptions {
    SaveToProduct,
    SaveAndAddToGallery
}

interface IState {
    selectedOption: SaveOptions;
}

class SaveMotiveDialogComponent extends React.Component<ISaveMotiveDialogProps, IState> {
    constructor(props: ISaveMotiveDialogProps) {
        super(props);

        this.state = {
            selectedOption: SaveOptions.SaveToProduct
        }
    }

    private handleSave() {
        switch (this.state.selectedOption) {
            case SaveOptions.SaveToProduct:
                this.props.onSave(false, false);
                break;
            case SaveOptions.SaveAndAddToGallery:
                this.props.onSave(true, true);
                break;
            default:
                throw new Error(`Unknown option ${this.state.selectedOption}!`)
        }
    }

    public render() {
        return (
            <div className="medium-popup-dialog-root save-motive-dialog">
                <div className="title primary-style" >
                    <h3>{localization.editorLoc.logoEditorContent.saveMotiveDialogTitle}</h3>
                </div>
                <div className="content-container">
                    <div className="options-selection">
                        <div className="selector" onClick={() => this.setState({selectedOption: SaveOptions.SaveToProduct})}>
                            <div className={'radio-outter ' + ((this.state.selectedOption === SaveOptions.SaveToProduct) ? 'primary-style' : 'checkmark-unchecked')}>
                                <div className="radio-inner"></div>
                            </div>
                            <div className="selection-label">
                                <Markdown text={localization.editorLoc.logoEditorContent.saveMotiveDialogOptionForProduct} />
                            </div>
                        </div>
                        <div className="selector" onClick={() => this.setState({selectedOption: SaveOptions.SaveAndAddToGallery})}>
                            <div className={'radio-outter ' + ((this.state.selectedOption === SaveOptions.SaveAndAddToGallery) ? 'primary-style' : 'checkmark-unchecked')}>
                                <div className="radio-inner"></div>
                            </div>
                            <div className="selection-label">
                                <span>
                                    <Markdown text={localization.editorLoc.logoEditorContent.saveMotiveDialogOptionForAll} />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="buttons-row">
                        <button
                            className="dialog-button primary-style"
                            onClick={() => this.handleSave()}>
                            {localization.commonLoc.accept}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export const SaveMotiveDialog = (props: ISaveMotiveDialogProps) => <SaveMotiveDialogComponent {...props} />


// WEBPACK FOOTER //
// ./src/App/logo-app/logo-editor/logo-editor-dialogs/save-motive.dialog.tsx